
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class CollapsibleDescription extends Vue {
    @Prop({ type: String, default: undefined }) readonly description!: string;
    @Prop({ type: Number, default: 100 }) readonly descriptionMaxLength!: number;
    @Prop({ type: String, default: 'expand', required: false }) readonly expandText!: string;
    @Prop({ type: String, default: 'collapse', required: false }) readonly collapseText!: string;
    @Prop({ type: String, default: '', required: false }) readonly paraClasses!: string;

    expanded: boolean = false;

    get descriptionParagraphs(): string[] {
      return this.shownDescription.split("\n");
    }

    get expandButtonText(): string {
      return this.expanded ? this.collapseText : this.expandText;
    }

    toggleExpandDescription(): void {
      this.expanded = !this.expanded;
    }

    get shownDescription(): string {
      if (!this.shouldDescriptionBeShortened) {
        return this.description;
      }

      if (this.expanded) {
        return this.description;
      }

      return this.shortDescription(this.description);
    }

    get shouldDescriptionBeShortened(): boolean {
      return this.description.length > this.descriptionMaxLength;
    }

    shortDescription(description: string): string {
      if(this.descriptionMaxLength === 0){
        return ''
      }
      const maxLengthDescription = description.substr(0, this.descriptionMaxLength);
      const truncatedToLastSpace = maxLengthDescription.substr(0, maxLengthDescription.lastIndexOf(" "));
      return `${truncatedToLastSpace}...`;
    }

    getParagraphClasses(index: number) {
      return {
        "inline": index + 1 === this.descriptionParagraphs.length,
[this.paraClasses]: true
      };
    }
  }
